<template>
    <div>
        <div class="developers-title">
           开发商应用系统
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
}
</script>
<style lang="scss" scoped>
    @import '../../style/homepage/developers.scss'
</style>


// WEBPACK FOOTER //
// src/components/homepage/Developers.vue